import axios from "axios";
import { firebaseBase } from "../constants/dbConstants";

const SERVER_BASE = process.env.REACT_APP_SERVER_BASE;

export async function getUserInfo(userId, token) {
  const response = await axios.get(
    `${firebaseBase}/Users/${userId}.json?auth=${token}`
  );
  return response;
}

export async function getDoctors(token) {
  const url = `${firebaseBase}/Users.json?auth=${token}`;
  const response = await axios.get(url);
  return response;
}

export async function saveUserInfo(data, token) {
  const url = `${firebaseBase}/Users.json?auth=${token}`;
  return await axios.patch(url, data);
}

export async function storeAdverseReactions(data, token) {
  const url = `${firebaseBase}/AdverseReactions.json?auth=${token}`;
  return await axios.post(url, data);
}

export async function updateUserInfo(userId, data, token) {
  const url = `${firebaseBase}/Users/${userId}.json?auth=${token}`;
  return await axios.patch(url, data);
}

export async function updatePatientsInfo(path, userId, data, token) {
  const url = `${firebaseBase}/Users/${userId}/patients/${path}.json?auth=${token}`;
  return await axios.patch(url, data);
}

export async function createPatient(data, doctorId, token) {
  const url = `${firebaseBase}/Users/${doctorId}/patients.json?auth=${token}`;
  return await axios.patch(url, data);
}

export async function getDoctorPatients(doctorId, token) {
  const url = `${firebaseBase}/Users/${doctorId}/patients.json?auth=${token}`;
  const response = await axios.get(url);
  return response;
}

export async function getPatient(doctorId, patientId, token) {
  const url = `${firebaseBase}/Users/${doctorId}/patients/${patientId}.json?auth=${token}`;
  const response = await axios.get(url);
  return response;
}

export async function getPatientQuestionary(doctorId, path, token) {
  const url = `${firebaseBase}/Users/${doctorId}/patients/${path}.json?auth=${token}`;
  const response = await axios.get(url);
  return response;
}

export async function sendEmail(subject, message, receivers) {
  let response = "";
  try {
    response = await axios.post(`${SERVER_BASE}/mailsend`, {
      subject,
      message,
      receivers,
    });
  } catch (error) {
    console.log(error);
    response = `error: ${error}`;
  }
  return response.data;
}

export async function getCiData(patientId, doctorId) {
  const url = `${SERVER_BASE}/consentmentinfo?doctorId=${doctorId}&patientId=${patientId}`;
  const response = await axios.get(url);
  return response.data;
}

export async function downloadData() {
  const headers = { "Content-Type": "blob" };
  const config = {
    method: "GET",
    url: URL,
    responseType: "arraybuffer",
    headers,
  };
  const response = await axios.get(`${SERVER_BASE}/data`, config);
  return response;
}
